import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RestoreSmsCampaign as RestoreSmsCampaignMutation,
    RestoreSmsCampaignVariables,
} from 'nutshell-graphql-types';

import RESTORE_SMS_CAMPAIGN from '../../../broadcasts/graphql/mutations/restore-sms-campaign.graphql';

import {dripSequenceDeleteRestoreUpdate} from '../../helpers';

export function useRestoreSmsDripSequence(): {
    restoreCampaign: (id: string) => Promise<any>;
    isRestoring: boolean;
    error: string | null | undefined;
} {
    const [restoreCampaign, {loading, error}] = useMutation<
        RestoreSmsCampaignMutation,
        RestoreSmsCampaignVariables
    >(RESTORE_SMS_CAMPAIGN);

    return {
        restoreCampaign: (id: string) =>
            restoreCampaign({
                variables: {input: {id}},
                update: (proxy, mutationResults) => {
                    // Get the restored dripSequence
                    const restoredDripSequence =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.smsCampaignRestore &&
                        mutationResults.data.smsCampaignRestore.campaign;

                    if (!restoredDripSequence) return;

                    dripSequenceDeleteRestoreUpdate(proxy, restoredDripSequence, false);
                },
            }),
        isRestoring: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
